"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerGuestsSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const memberMultiSelect_1 = require("@/app/SUMOCEP/components/memberMultiSelect");
const scheduler_1 = require("@/app/SUMOCEP/store/scheduler");
const outline_1 = require("@heroicons/react/24/outline");
const react_redux_1 = require("react-redux");
const SchedulerGuestsSection = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const potentialMembers = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectPotentialMembers);
    const selectedMemberIds = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectSelectedMemberIds);
    const mainGuest = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectMainGuest);
    const guests = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectGuests);
    const isLoaded = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectIsSchedulerLoaded);
    const showMainGuestError = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectShowMainGuestError);
    const usersColor = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectSelectedUsersColors);
    const mainGuestValidSubTypes = ["CONTACT" /* MemberSubType.CONTACT */, "LEAD" /* MemberSubType.LEAD */];
    const handleGuestsChange = (members) => {
        const firstMember = members.find((member) => mainGuestValidSubTypes.includes(member.subType) && member.type !== "CUSTOM" /* MemberType.CUSTOM */);
        if (firstMember !== mainGuest) {
            dispatch(scheduler_1.SUMOCEPSchedulerActions.setMainGuest(firstMember || null));
        }
        if (members !== guests) {
            dispatch(scheduler_1.SUMOCEPSchedulerActions.setGuests(members.filter((member) => member !== firstMember)));
        }
    };
    const handleSearch = (value) => {
        dispatch(scheduler_1.SUMOCEPSchedulerActions.getAttendeesSearchRequest(value));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-8px', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-label-s-med text-gray-80', children: labels_1.default.INVITEE_AMD_ATTENDEES }), !isLoaded ? ((0, jsx_runtime_1.jsx)("div", { className: 'add-button mr-20px mb-12px', children: (0, jsx_runtime_1.jsx)(outline_1.PlusIcon, { className: 'icon-16px' }) })) : ((0, jsx_runtime_1.jsx)(memberMultiSelect_1.MemberMultiSelect, { options: potentialMembers, mainGuest: mainGuest, starOptions: mainGuestValidSubTypes, selectedIds: selectedMemberIds, usersColor: usersColor, invalid: showMainGuestError, onChange: handleGuestsChange, onDebounceSearch: handleSearch }))] }));
};
exports.SchedulerGuestsSection = SchedulerGuestsSection;
